export const environment = {
    production: false,
    staging: true,
    appInsights: {
        instrumentationKey: null
    },
    agGrid: {
        license:
            'Using_this_{AG_Grid}_Enterprise_key_{AG-056659}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{DataGenic_Spain}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{Sphere}_only_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_working_on_{Sphere}_need_to_be_licensed___{Sphere}_has_been_granted_a_Deployment_License_Add-on_for_{1}_Production_Environment___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{17_May_2025}____[v3]_[01]_MTc0NzQzNjQwMDAwMA==73ac7b76b0fbea5881a0ee5a058500bf'
    },
    idpHint: undefined,
    build: {
        version: '{PLATFORM_VERSION}',
        appVersion: '{APP_VERSION}',
        buildDate: '{BUILD_DATE}',
        buildNumber: '{BUILD_NUMBER}'
    }
};
